export default {
  loading: 'Loading…',
  location_list: {
    health_summary: {
      title: 'Location health · %{total} total',
      label_healthy: 'Healthy',
      label_errors: 'With errors',
      label_notices: 'With notices',
      filter_by_errors: 'Filter by locations with errors',
      filter_by_notices: 'Filter by locations with notices',
    },
    details_modal: {
      title: 'Location details',
      aria_label: 'Location details for %{name}',
      address: 'Address',
      ordering_url: 'Ordering URL',
      external_id: 'External ID',
      phone_number: 'Phone',
      pos: 'POS',
      timezone: 'Timezone',
      phone_save: 'Save',
      phone_saved: 'Phone number saved.',
      phone_invalid: 'Enter a valid 10-digit phone number.',
      phone_save_failed: "We couldn't save the phone number.",
      phone_edit_announce: 'Editing phone number. Press Enter to save.',
      edit_phone_aria: 'Edit phone number for %{name}',
      phone_input_aria: 'Phone number',
    },
    phone: {
      edit_modal: {
        address: 'Address',
        title: 'Update phone number',
        phone: 'Phone',
        submit: 'Save phone number',
        success: 'Success! The location phone number was saved.',
      },
    },
    list_title: 'Location list',
    page_title: 'Locations | Thanx',
    search_placeholder: 'Search locations by name or address',
    filters: {
      country: 'Country',
      state: 'State',
    },
    ctas: {
      enable_selected: 'Enable selected locations',
      disable_selected: 'Disable selected locations',
      bulk_failed:
        'We couldn’t change the ordering status for the selected locations.',
      bulk_all_skipped:
        'None of the selected locations are configured for ordering yet, so nothing was changed.',
      bulk_partial_skipped_one:
        '%{count} selected location isn’t configured for ordering yet and was skipped.',
      bulk_partial_skipped_other:
        '%{count} selected locations aren’t configured for ordering yet and were skipped.',
      toggle_failed:
        'We couldn’t change the ordering status for that location.',
      enable_failures_heading_one:
        'Ordering couldn’t be enabled for this location:',
      enable_failures_heading_other:
        'Ordering couldn’t be enabled for %{count} locations:',
      // Fallback label when a failed location_id isn't in the loaded list.
      location_fallback: 'Location %{id}',
    },
    select_all: 'Select all',
    deselect_all: 'Deselect all',
    selected_count: '%{count} selected',
    badge: {
      ordering_enabled: 'Ordering enabled',
      ordering_disabled: 'Ordering disabled',
      healthy: 'Healthy',
      errors_one: '%{count} error',
      errors_other: '%{count} errors',
      notices_one: '%{count} notice',
      notices_other: '%{count} notices',
    },
    row_checkbox_label: 'Select %{name}',
    pagination: {
      prev: 'Prev',
      next: 'Next',
      page: 'Page',
      of: 'of %{count}',
      per_page_label: 'Show',
      per_page_suffix: 'per page',
      per_page_aria: 'Items per page',
    },
    help: {
      title: 'Help',
      enable_disable: 'How to enable and disable locations',
      troubleshoot_menu_errors: 'How to troubleshoot menu errors',
      opens_in_new_tab: 'opens in a new tab',
    },
    table: {
      location: 'Location',
      location_status: 'Location status',
      ordering_status: 'Ordering status',
      view: 'View',
      view_aria: 'View details for %{name}',
      checkbox_header: 'Select',
      actions_header: 'Actions',
      view_header: 'View',
      row_overflow_header: 'Row actions',
      row_actions_label: 'Actions for %{name}',
      enable_ordering: 'Enable ordering',
      disable_ordering: 'Disable ordering',
      phone: 'Phone',
      view_details: 'View Details',
      edit: 'Edit',
    },
    tabs: {
      locations: 'Locations',
      menu_errors: 'Menu errors',
    },
    detail: {
      banner_message:
        'Menu errors are grouped by menu, not by location. Since most menus are shared across many locations, fix once in your menu configuration, and it resolves everywhere that menu is used.',
      provider: {
        toast: 'Toast',
        olo: 'Olo',
      },
      severity: {
        error: 'Error',
        notice: 'Notice',
      },
      badge: {
        errors: 'errors',
        notices: 'notices',
      },
      used_in_locations: 'Used in %{count} locations',
      view_support: 'View what Thanx supports',
    },
    loading: 'Loading locations…',
    load_error:
      'Couldn’t load locations. Confirm the merchant has an ordering provider configured, then refresh.',
    location_detail: {
      back: 'Back',
      not_found: 'Location not found.',
      page_title: '%{name} | Locations | Thanx',
      cta_disable: 'Disable ordering at this location',
      cta_enable: 'Enable ordering at this location',
      view_details: 'View details',
      last_updated: 'Last updated %{timestamp}.',
      not_yet_synced: 'Not yet synced.',
      loading: 'Loading location…',
      toggle_failed:
        'We couldn’t change the ordering status for this location.',
      enable_failed: 'Ordering couldn’t be enabled: %{reasons}',
      update: 'Update',
      menu_errors_crosslink: {
        message: 'Menu issues may be affecting this location.',
        link: 'View menu issues',
      },
      schedule_overrides: {
        title: 'Upcoming schedule overrides',
        // Middot separating the override's date from its handoff mode in the
        // row header; kept in i18n so the raw Unicode char stays out of JSX.
        header_separator: '·',
        description:
          'The following schedule overrides are configured for this location in the Toast dashboard.',
        empty:
          'No upcoming schedule overrides are configured for this location.',
        closed: 'Closed',
        hours_range: '%{open}–%{close}',
        // Comma-separates all but the last range; hours_joiner precedes the
        // final one — "09:00–11:00, 13:00–17:00 and 18:00–21:00".
        hours_separator: ', ',
        hours_joiner: ' and ',
        handoff_mode: {
          pickup: 'Pickup',
          delivery: 'Delivery',
          dine_in: 'Dine-in',
        },
      },
      menus_enabled: {
        title: 'Menus enabled for this location',
        description:
          'These menus are associated with this location by your ordering provider and are enabled for use by the Thanx ordering experiences.',
      },
      menus_disabled: {
        title: 'Menus not enabled for this location',
        description:
          'These menus are associated with this location by your ordering provider but are not enabled for use by the Thanx ordering experiences.',
      },
      menu_column: 'Menu',
      issues: {
        source_generic: 'Error from ordering provider',
        source_provider: 'Error from %{provider}',
        no_enabled_menu: {
          title: 'No enabled menu',
          guidance:
            'Customers can’t order from this location until a menu is enabled in the Toast dashboard.',
        },
        no_handoff_modes: {
          title: 'No mapped handoff modes',
          guidance:
            'Customers can’t choose pickup or delivery. Map at least one handoff mode in the Toast dashboard.',
        },
        multiple_handoff_mappings: {
          title: 'Multiple handoff mode mapping',
          guidance:
            'The same handoff type is set up more than once at this location. Remove duplicates to avoid unexpected behavior.',
        },
        missing_discount: {
          title: 'Missing Toast discount',
          guidance:
            'Rewards can’t be applied at checkout. Contact Thanx support to configure.',
        },
        missing_payment_uid: {
          title: 'Missing Toast alternate payment type UID',
          guidance: 'Contact Thanx support to configure.',
        },
        missing_phone: {
          title: 'Missing phone number',
          guidance: 'Delivery drivers can’t contact the store at pickup.',
        },
        corrupted_data: {
          title: 'Unable to load error details',
          guidance:
            'This location’s error data couldn’t be read. Update to retry, or contact Thanx support if it persists.',
        },
        service_charge_health: {
          title: 'Service charge issue',
          guidance:
            'One or more service charges couldn’t be verified with the ordering provider. Trigger a refresh, or contact Thanx support if this persists.',
        },
      },
      service_charges: {
        title: 'Service charges',
        manage_link: 'Manage in Service Charges',
        loading: 'Loading service charges…',
        empty: 'No service charges are configured for this location.',
        fetch_error: 'Failed to load service charges. Please try refreshing.',
        edit: 'Edit',
        save_success: 'Your service charge changes have been saved.',
        save_error: 'Failed to save. Please try again.',
        health_issue: {
          silenced_charge:
            '%{amount} %{name} is silenced by criteria_override — Toast already sets %{criteria} for this charge.',
        },
        editing_disabled_reason:
          'Finish editing the other service charge first.',
        redemption_needs_active_reason:
          'Turn on ‘Active in Thanx ordering’ first — rewards can only be redeemed against a charge that’s applied to orders.',
        redemption_gratuity_reason:
          'Rewards can’t be redeemed against gratuity charges, they never discount a tip.',
        amount_varies: '(amount varies)',
        recommended_badge: 'Recommended for delivery',
        table: {
          service_charge: 'Service charge',
          calculation: 'Calculation',
          delivery: 'Delivery',
          pickup_takeout: 'Pickup',
          thanx_enabled: 'Active in Thanx ordering',
          eligible_for_redemption: 'Eligible for redemption',
          actions: 'Actions',
          delivery_help: 'Applies to: Delivery, Dispatch',
          pickup_takeout_help:
            'Applies to: Counter Pickup, Curbside, Drive-thru',
          eligible_for_redemption_help:
            'Let guests redeem rewards against this charge, such as Free or Discounted Delivery rewards. Rewards can’t be redeemed against gratuity charges.',
          thanx_enabled_help:
            "When on, this charge is added to orders placed through Thanx online ordering. It doesn't change your in-store or Toast-native channels.",
          applies_to: 'Applies to',
          applies_to_help:
            'The order types this charge applies to. Toast-controlled charges are read-only; for the rest, you choose where it applies.',
          info_button_aria: '%{label} information',
        },
        applies_to: {
          toast_controlled: 'Controlled in Toast',
          both: 'Delivery + Pickup',
          delivery: 'Delivery',
          pickup: 'Pickup',
          none_yet: 'No order types yet',
          not_set: 'Not set. Choose order types with Edit.',
          sentence_delivery: 'Delivery orders',
          sentence_pickup: 'Pickup orders',
          sentence_both: 'Delivery & Pickup orders',
        },
        edit_modal: {
          title: 'Edit %{name}',
          description:
            'Choose which order types this charge applies to for Thanx online ordering.',
          meta_id: 'ID: %{id}',
          question: 'Apply this fee to:',
          save: 'Save changes',
        },
        taxable: 'Taxable',
        non_taxable: 'Non-taxable',
        amount_type_labels: {
          FIXED: 'Fixed',
          PERCENT: 'Percent',
          OPEN: 'Open',
        },
        id_label: 'ID: %{uid}',
        gratuity_tag: 'gratuity',
        open_tag: 'open',
        delivery_toggle_aria: 'Delivery for %{name}',
        pickup_toggle_aria: 'Pickup for %{name}',
        thanx_enabled_toggle_aria: 'Active in Thanx ordering for %{name}',
        eligible_for_redemption_toggle_aria:
          'Eligible for redemption for %{name}',
        sync: {
          started: 'Service charge refresh requested from %{provider}.',
          error: 'Failed to request a refresh. Please try again.',
          last_synced: 'Last synced %{time}',
          update_action: 'Update from Toast',
        },
      },
    },
    service_charge_groups: {
      title: 'Service charges',
      page_title: 'Service charges | Locations | Thanx',
      description:
        'One row per distinct service charge across your locations. Select a row to see how it’s applied location by location.',
      loading: 'Loading service charge groups…',
      fetch_error:
        'Failed to load service charge groups. Please try refreshing.',
      locations_fetch_error:
        'Failed to load your accessible locations. Please try refreshing.',
      empty_no_filters: 'No service charges configured.',
      empty_filtered: 'No charges match these filters.',
      empty_no_accessible_locations:
        'You don’t have access to any locations. Contact an admin if you believe this is a mistake.',
      clear_filters: 'Clear filters',
      filters: {
        search_placeholder: 'Search by name',
        search_aria: 'Search service charge groups by name',
        type_label: 'Amount type',
        type_placeholder: 'All amount types',
        type_options: {
          fixed: 'Fixed',
          percent: 'Percent',
          open: 'Open',
        },
        enabled_label: 'Thanx status',
        enabled_placeholder: 'All statuses',
        enabled_options: {
          enabled: 'Enabled',
          disabled: 'Disabled',
        },
        handoff_label: 'Handoff mode',
        handoff_placeholder: 'All handoff modes',
        handoff_options: {
          unknown: 'Unknown',
          pickup: 'Pickup',
          delivery: 'Delivery',
          curbside: 'Curbside',
          tableside: 'Tableside',
          drivethru: 'Drive-thru',
          dinein: 'Dine-in',
        },
        location_multi_select: {
          select_locations: 'Locations',
          locations_selected_one: '%{count} location selected',
          locations_selected_other: '%{count} locations selected',
          no_locations_available: 'No locations available.',
          search_locations: 'Search locations',
          no_locations_match: 'No locations match your search.',
        },
      },
      table: {
        name: 'Name',
        amount_type: 'Type',
        locations: 'Locations',
        enabled: 'Enabled',
        override_delivery: 'Delivery overrides',
        override_takeout: 'Takeout overrides',
        divergence: 'Consistency',
        view_header: 'View',
        view_aria: 'View locations for %{name}',
      },
      divergence_badge: {
        divergent: 'Divergent',
        consistent: 'Consistent',
      },
      recommended_badge: 'Recommended for delivery',
      provider_uid_label: 'ID: %{uid}',
      drill_down: {
        title: 'Locations for %{name}',
        title_generic: 'Locations for this service charge',
        page_title: '%{name} | Service charges | Thanx',
        page_title_generic: 'Service charges | Thanx',
        description:
          'Every location that carries this service charge, as reported by your ordering provider.',
        loading: 'Loading locations…',
        fetch_error: 'Failed to load locations. Please try refreshing.',
        empty: 'No locations carry this service charge.',
        yes: 'Yes',
        no: 'No',
        not_overridden: 'Not overridden',
        amount_type_labels: {
          FIXED: 'Fixed',
          PERCENT: 'Percent',
        },
        table: {
          location: 'Location',
          amount: 'Amount',
          enabled: 'Applied to Thanx orders',
          delivery_override: 'Delivery override',
          takeout_override: 'Takeout override',
        },
      },
    },
    title: 'Locations',
  },
}
